import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7301Model } from '../kymw7301.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetCouponResponse = {
  CouponCategory: string;
  CouponOrderCd: string;
  NoticeExistenceType: string;
  NoticeMethodTypeItem: string;
  NoticeMethodTypeMail: string;
  UseStandardPrice: string;
  StartMemberWeek: string;
  EndMemberWeek: string;
  CouponIssueCatalogStart: string;
  CouponIssueCatalogEnd: string;
  ValidWeek: string;
  CouponReceiptCatalogStart: string;
  CouponReceiptCatalogEnd: string;
  DiscountPrice: string;
  CouponName: string;
  CouponNameKana: string;
  EcTitle: string;
  DetailsTitle: string;
  UseTerms: string;
  DiscountedAmount: string;
  ValidatedDate: string;
  CpgrpCd: string;
  CouponGoodsNo: string;
  CoopCodeList: [
    {
      CoopCode: string;
    }
  ];
};

/**
 * 注文単位値引クーポン情報取得サービス
 *
 * @export GetCouponService
 * @class GetCouponService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCouponService extends PlessJsonResponderSub<GetCouponResponse> {
  private model: KYMW7301Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCouponListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CouponGoodsNo: this.model.couponGoodsNo,
        CouponReceiptCatalogStart: this.model.couponReceiptCatalogStart,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetCouponListService
   */
  execute(model: KYMW7301Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getCoupon', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof GetCouponListService
   */
  success(data: GetCouponResponse) {
    this.model.setSearchResult(data);
    if (this.calbak) this.calbak();
  }
}
